import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { API_ADMIN_ASPECTO, API_ADMIN_TIPO_FAENA, URL_SUPPORT, ROW_COUNT } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import IAspecto from "../../../entities/IAspecto";
import AdminLista from "../AdminLista";
import { cParamsActiveOrderTitle } from "../../../helpers/paramsHelper";

interface IAspectoProps {
  cbAspecto?: Array<IAspecto>;
  is_test?: boolean;
}

const Aspecto = ({ cbAspecto, is_test }: IAspectoProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [comboVcc, setComboVcc] = useState<Array<IAspecto>>(cbAspecto || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let params = { PAGINA: 1, PAGINADO: pageSize, ORDENADOPOR: "ID", ORIENTACION: "DESC" };
    let result = is_test
      ? { data: [] }
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_ASPECTO}/getall`, { Authorization: `Bearer ${token}` }, params)).result;
    let list = result.data;
    setListItems(list);
    params.PAGINADO = ROW_COUNT;
    let pages = result.pages;
    setPages(pages);

    const combo = (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_FAENA}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle)).result
      .data;
    setComboVcc(combo);
    setIsLoading(false);
  }, [token]);

  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };
  const filter = (filter: any, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.NOMBRE_TIPO_ASPECTO = filter.ID_TIPO_ASPECTO?.toString() || "";
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_ASPECTO}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };
  const edit = (value: any, filters: any) => {
    delete value.TRANSACTION_ID;
    if (value.ID === "") {
      delete value.ID;
    }
    postAPI(`${URL_SUPPORT}${API_ADMIN_ASPECTO}`, value, { Authorization: `Bearer ${token}` })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID > 0);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ID: "",
              ACTIVO: true,
              ID_ACTO: "1",
              ID_TIPO_CAUSA: 1,
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
              TIPO_CAUSA: "",
              TITULO: "",
            },
            {}
          );
          filter({});
          filter({ PAGINA: 1 });
          filter({ PAGINA: 1 }, true);
          filter({ PAGINA: undefined });
          paging(1);
        }}></button>
      <AdminLista
        reload={filter}
        items={[
          {
            type: "ID_TIPO_ASPECTO",
            value: comboVcc.map((vcc) => {
              return { text: vcc.TITULO, value: vcc.ID };
            }),
          },
        ]}
        callback={edit}
        data={listItems}
        tipo={"Aspecto"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Aspecto"
        hideAdd={false}
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default Aspecto;
